import { render, staticRenderFns } from "./PasswordData.vue?vue&type=template&id=3189d542&"
import script from "./PasswordData.vue?vue&type=script&lang=js&"
export * from "./PasswordData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports